export const preAuthTransactionPaths = {
  PRE_AUTH_TRANSACTION_LIST: '',
};